module.exports = __webpack_public_path__ + "img/eintracht-frankfurt-logo-icon.a47be4aa.png";